import React from 'react';

const Help = () => {
    return (
        <div className="space-y-6">
            <div className="border-b pb-4">
                <h3 className="text-lg font-semibold text-gray-800 mb-2">Manage Meter History</h3>
                <p className="text-sm text-gray-600">
                    Track odometer and usage readings for your vehicles.
                </p>
            </div>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Recording Readings</h4>
                <ul className="list-disc pl-5 space-y-2 text-sm text-gray-600">
                    <li>Click <strong>Add Meter</strong> to record a new reading.</li>
                    <li>Select the <strong>Vehicle</strong> and enter the current <strong>Value</strong> (e.g., mileage or hours).</li>
                </ul>
            </section>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Analyzing Usage</h4>
                <ul className="list-disc pl-5 space-y-2 text-sm text-gray-600">
                    <li>Use the <strong>Date Range Picker</strong> to view readings over a specific period.</li>
                    <li>Use the <strong>Search Bar</strong> to filter by vehicle name or other details.</li>
                </ul>
            </section>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Export Data</h4>
                <ul className="list-disc pl-5 space-y-2 text-sm text-gray-600">
                    <li>Select specific readings using the checkboxes.</li>
                    <li>Export the history to <strong>PDF</strong> or <strong>CSV</strong> for reporting or analysis.</li>
                </ul>
            </section>
        </div>
    );
};

export default Help;
